import { SkeletonSpinnerCentered } from '@civilgrid/ui/SkeletonLoader';
import { bbox } from '@turf/turf';
import { useEffect, useState } from 'react';
import type { Project } from '~/common/types';
import { MapComponent } from '~/components2/Map';
import type { InitialViewState } from '~/components2/Map/common';
import { onRootBasemapChange } from '~/pages/common/helpers';
import rootStore from '~/store';
import EditorSurface from './EditorSurface';
import { EditProjectPanel } from './EditPanel';
import Surface from './Surface';
import store from './store';

interface Props {
  project: Project;
  refetch: () => void;
}

export default function EditProjectGeometryMap({ project, refetch }: Props) {
  const [isLoading, setIsLoading] = useState(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await store.bootstrap(project);
      setIsLoading(false);
    })();

    return () => {
      store.reset();
    };
  }, []);

  if (isLoading) {
    return <SkeletonSpinnerCentered />;
  }

  const projectBounds = bbox(project.geometry);

  const initialViewState: InitialViewState = {
    bounds: [projectBounds[0], projectBounds[1], projectBounds[2], projectBounds[3]],
    fitBoundsOptions: {
      padding: 100,
    },
  };

  return (
    <div className="flex h-full w-full">
      <MapComponent
        id="edit-geometry-map"
        store={store}
        mapStyle={rootStore.preferredBasemap}
        onBasemapChange={onRootBasemapChange}
        showLayers={true}
        showLayerPicker={true}
        showLegend={true}
        showBasemapPicker={true}
        showZoomButtons={true}
        showScale={true}
        printTool={false}
        allowRotation={true}
        measureTool={true}
        initialViewState={initialViewState}
      >
        <Surface />
        <EditorSurface />
        <EditProjectPanel project={project} refetch={refetch} />
      </MapComponent>
    </div>
  );
}
